var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#2F80ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 10.375C25.3477 10.375 25.875 10.9023 25.875 11.5C25.875 12.1328 25.3477 12.625 24.75 12.625H11.8125C11.4961 12.625 11.25 12.9062 11.25 13.1875C11.25 13.5039 11.4961 13.75 11.8125 13.75H24.75C25.9805 13.75 27 14.7695 27 16V23.875C27 25.1406 25.9805 26.125 24.75 26.125H11.25C9.98438 26.125 9 25.1406 9 23.875V12.625C9 11.3945 9.98438 10.375 11.25 10.375H24.75ZM23.625 21.0625C24.2227 21.0625 24.75 20.5703 24.75 19.9375C24.75 19.3398 24.2227 18.8125 23.625 18.8125C22.9922 18.8125 22.5 19.3398 22.5 19.9375C22.5 20.5703 22.9922 21.0625 23.625 21.0625Z",
    fill: "#FCFCFC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.a5cadd1760b1c7031ff5f842e47b591c.svg";
export { ForwardRef as ReactComponent };